import { useMemo } from 'react'
import Chart from 'react-apexcharts'

function UsageChart({ data, title = 'Utilisation au fil du temps' }) {
  const options = useMemo(() => ({
    chart: {
      id: 'usage-chart',
      type: 'line',
      toolbar: {
        show: true,
        tools: {
          download: true,
          zoom: true,
          pan: true,
          reset: true,
        },
      },
      zoom: {
        enabled: true,
      },
    },
    title: {
      text: title,
      align: 'left',
      style: {
        fontSize: '16px',
        fontWeight: 600,
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeFormatter: {
          day: 'dd MMM',
        },
      },
    },
    yaxis: {
      title: {
        text: 'Nombre de requêtes',
      },
      min: 0,
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    markers: {
      size: 4,
      hover: {
        size: 6,
      },
    },
    tooltip: {
      x: {
        format: 'dd MMM yyyy',
      },
    },
    colors: ['#0d6efd', '#6c757d', '#198754', '#dc3545', '#ffc107'],
    legend: {
      position: 'top',
      horizontalAlign: 'right',
    },
    grid: {
      borderColor: '#e7e7e7',
      strokeDashArray: 4,
    },
    noData: {
      text: 'Aucune donnée disponible',
      align: 'center',
      verticalAlign: 'middle',
    },
  }), [title])

  const series = useMemo(() => {
    if (!data || data.length === 0) {
      return []
    }

    // If data is already in ApexCharts format
    if (data[0]?.data) {
      return data
    }

    // Transform data to ApexCharts format
    // Expected format: [{ date: '2026-01-01', count: 100 }]
    return [{
      name: 'Requêtes',
      data: data.map(item => ({
        x: new Date(item.date).getTime(),
        y: item.count || item.value || 0,
      })),
    }]
  }, [data])

  return (
    <div className="usage-chart">
      <Chart
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </div>
  )
}

export default UsageChart
